import { TFormalOffers } from './formalOffers.types';

/**
 * Gets the highest interest-only period from an array of formalOffers
 *
 * @param formalOffers An array of Formal Offers.
 * @returns the highest interest_only_repayments value
 */
export const getFormalOffersMaxInterestOnlyPeriod = (
    formalOffers: TFormalOffers
) => {
    return Math.floor(
        formalOffers.reduce<number>((max, offer) => {
            const maxPeriod = offer.interest_only_repayments || 0;
            return maxPeriod > max ? maxPeriod : max;
        }, 0)
    );
};
